import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { TakeProfitOrder } from '@/store/orders/takeProfitOrder/state.ts';

export const SavedTakeProfitOrderValidator = arkScope.type({
  type: "'TakeProfitOrder'",
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    clientWay: "'buy' | 'sell'",
    notional: 'number?',
    notionalCurrencyIndex: '1 | 2',
    limitPrice: 'number?',
    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      tiering: 'string?',
    },
    expiry: arkScope
      .type({ type: "'GoodTillCancelled'" })
      .or({ type: "'ExpiryDate'", date: 'string?', time: 'string?' }),
    customerPrice: 'number?',
    commercialMargin: 'number?',
    'notificationEmails?': 'string[]',
    isReadyToSubmit: 'boolean',
    clockOffset: 'number?',
    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  clientId: 'number?',
});

export type SavedTakeProfitOrder = typeof SavedTakeProfitOrderValidator.infer;

export const SavedTakeProfitOrder = {
  fromFxTakeProfitOrder: (fxTile: TakeProfitOrder, tileId: string): SavedTakeProfitOrder => ({
    type: 'TakeProfitOrder',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
